import React, { Component } from "react";

import { DKLabel } from "deskera-ui-library";
import Incrementor from "../../common/Incrementor";
import WidthEditor from "./WidthEditor";
import SegmentControl from "../../common/SegmentControl";

/*
PROPS
- data // this is current componets data
- onDataChange
*/

class CommonEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }

  render() {
    return (
      <div
        className={
          "parent-width border-box mt-l pb-xxl " + this.props.className
        }
      >
        <div className="border-box parent-width border-m shadow-s p-r border-radius-s">
          <DKLabel text="Position" className="fw-m mb-s" />
          <SegmentControl
            data={[
              { title: "Left", value: "flex-start" },
              { title: "Center", value: "center" },
              { title: "Right", value: "flex-end" },
            ]}
            onChange={this.changeSelfAlignment}
            value={this.componentData.style.alignSelf}
          />

          <Incrementor
            className="mt-l"
            title="Border radius"
            value={this.componentData.style.borderRadius}
            onChange={(value) => {
              this.changeStyle("borderRadius", value);
            }}
          />

          <div className="mt-l row">
            <DKLabel text={`Background color:`} className="fw-m" />
            <input
              type="color"
              className="ml-r"
              value={this.componentData.style.backgroundColor}
              onChange={(e) =>
                this.changeStyle("backgroundColor", e.target.value)
              }
            />
          </div>

          <WidthEditor
            className="mt-xl"
            data={this.props.data}
            onDataChange={this.props.onDataChange}
          />
        </div>

        {/* ////////////////////////////////////////////////////////////////////////////////////////// */}
        {/* ////////////////////////////////////////////////////////////////////////////////////////// */}

        {this.getPaddingSection()}
        {this.getMarginSection()}
      </div>
    );
  }

  getPaddingSection() {
    return (
      <div className="column parent-width mt-l shadow-s border-m p-r border-radius-s border-box">
        <DKLabel text="Padding" className="fw-m" />
        <div className="row justify-content-between mt-r">
          {this.getIncrementalView("Top", "paddingTop")}
          {this.getIncrementalView(
            "Bottom",
            "paddingBottom",
            this.changePadding
          )}
        </div>
        <div className="row justify-content-between mt-m">
          {this.getIncrementalView("Left", "paddingLeft")}
          {this.getIncrementalView("Right", "paddingRight")}
        </div>
      </div>
    );
  }
  getMarginSection() {
    return (
      <div className="column parent-width mt-l shadow-s border-m p-r border-radius-s border-box mb-xl">
        <DKLabel text="Margin" className="fw-m" />
        <div className="row justify-content-between mt-r">
          {this.getIncrementalView("Top", "marginTop")}
          {this.getIncrementalView("Bottom", "marginBottom")}
        </div>
      </div>
    );
  }

  getIncrementalView(title, property) {
    return (
      <div className="column">
        <DKLabel text={title} />
        <Incrementor
          className="mt-s"
          title={null}
          value={this.componentData.style[property]}
          onChange={(value) => {
            this.changeStyle(property, value);
          }}
        />
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  changeStyle = (property, value) => {
    let style = { ...this.componentData.style };
    style[property] = value;
    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };

  //////////////////////////////////////////////////////////////////////////////////////////

  changeSelfAlignment = (alignment) => {
    let style = { ...this.componentData.style };
    style.alignSelf = alignment;

    if (alignment === "flex-start") {
      style.marginRight = "auto";
      style.marginLeft = 0;
    } else if (alignment === "flex-end") {
      style.marginRight = 0;
      style.marginLeft = "auto";
    } else if (alignment === "center") {
      style.marginRight = "auto";
      style.marginLeft = "auto";
    }

    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };
}

export default CommonEditor;
